module.exports = "<div class=\"form-group\">\r\n        <input #input pattern=\"[0-9]+(\\.[0-9]{0,2})?%?\" class=\"form-control\" maxlength=\"5\"  required [(ngModel)]=\"params.data.verfied_hours\" style=\"width: 100%\"  placeholder='00.00'>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/inputrenderer/inputrenderer.component.html
// module id = ./src/app/inputrenderer/inputrenderer.component.html
// module chunks = main